<template>
  <div>
    <el-table v-loading="loading" :data="bodyphotoList">
      <el-table-column align="center" label="用户姓名" prop="userName" />
      <el-table-column align="center" label="用户手机号" prop="userPhone" />
      <el-table-column label="图片列表" align="center" prop="picList">
        <template slot-scope="scope">
          <img style="width: 50px;height: 50px" :src="scope.row.picList">
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center" prop="remark" />
      <el-table-column label="日期" align="center" prop="day" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.day, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="创建时间" align="center" prop="createDate" width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column align="center" label="是否展示" prop="valid">
        <template slot-scope="scope">
          <span v-if="scope.row.valid">是</span>
          <span v-if="!scope.row.valid">否</span>
        </template>
      </el-table-column>
    </el-table>



    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"/>
  </div>
</template>

<script>


import {
  addUserBodyphoto,
  delUserBodyphoto,
  getUserBodyphoto,
  listUserBodyphoto,
  updateUserBodyphoto
} from "@/api/biz/UserBodyphoto";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      // 总条数
      total: 0,
      // 用户体重记录表格数据
      bodyphotoList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询用户体重记录列表 */
    getList() {
      this.queryParams.userId = this.user.id;
      this.loading = true;
      listUserBodyphoto(this.queryParams).then(response => {
        this.bodyphotoList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
